import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading text-center text-foreground-950">
            为什么选择丫丫漫画
          </h2>
          <p className="mt-3 text-sm text-foreground-500 text-center">
            五大核心优势，打造极致的漫画阅读体验
          </p>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {featuresData.slice(0, 3).map((feature) => (
              <div
                key={feature.id}
                className="group p-6 bg-background-100 rounded-2xl border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                  <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                </div>
                <h3 className="text-lg font-heading text-foreground-950">
                  {feature.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {featuresData.slice(3, 5).map((feature) => (
              <div
                key={feature.id}
                className="group p-6 bg-background-100 rounded-2xl border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                  <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                </div>
                <h3 className="text-lg font-heading text-foreground-950">
                  {feature.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}